import React, { useState, useEffect } from "react";
import { ArrowRight, Check } from "lucide-react";
import {
  getImageRoot,
  isIOSDevice,
  isAndroidDevice,
} from "../../Utils/Utilities";

const STORE_LINKS = {
  android: "https://play.google.com/store/apps/details?id=com.sahicrm.androidapp",
  ios: "https://apps.apple.com/app/id6745503602",
};

const BRAND_DARK = "#0B1B2B";

export default function Download() {
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    setIsIOS(isIOSDevice());
  }, []);

  const targetUrl = isIOS ? STORE_LINKS.ios : STORE_LINKS.android;

  return (
    <div className="min-h-[100dvh] w-full !bg-[#f1f1f0] flex flex-col justify-between px-6 py-8 sm:py-10 max-w-full mx-auto font-sans select-none antialiased">
      {/* Top / Main Body */}
      <div className="w-full flex flex-col space-y-6 pt-2">
        {/* Badge: Account Created */}
        <div className="inline-flex items-center gap-1.5 px-1.5 pr-3 py-1 rounded-full bg-sahi-green-extra-light text-sahi-green text-xs sm:text-sm font-semibold w-fit">
          <span className="w-4 h-4 rounded-full bg-sahi-green-light flex items-center justify-center">
            <Check className="w-2.5 h-2.5 text-sahi-green stroke-[3.5]" />
          </span>
          <span>Account created</span>
        </div>

        {/* Headline & Subtitle */}
        <div className="space-y-3 text-left">
          <h1
            className="text-[28px] sm:text-[32px] font-extrabold leading-[1.2] tracking-tight"
            style={{ color: BRAND_DARK }}
          >
            Get the app to set up <br />
            your business
          </h1>
          <p className="text-[15px] sm:text-[16px] text-[#64748b] leading-relaxed">
            This takes about a minute. You'll pick up right where you left off.
          </p>
        </div>

        {/* App Icon Card */}
        <div className="w-full flex items-center justify-center py-4 sm:py-6">
          <div className="w-32 h-32 sm:w-36 sm:h-36 rounded-[28px] sm:rounded-[32px] bg-gradient-to-b from-white to-[#f8faf9] border border-zinc-200/80 shadow-2xl shadow-zinc-300/90 flex items-center justify-center p-5 relative overflow-hidden transition-transform duration-200 hover:scale-[1.02]">
            <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/40 to-white pointer-events-none" />
            <img
              src={getImageRoot("Images", "SahiCRM_Short_dark.png")}
              alt="SahiClub"
              className="w-20 h-20 sm:w-24 sm:h-24 object-contain drop-shadow-xs relative z-10"
            />
          </div>
        </div>

        {/* 3 Features / Value Points (Center aligned container, left aligned items) */}
        <div className="w-full flex justify-center pt-8 sm:pt-12 pb-2">
          <div className="w-fit flex flex-col space-y-4">
            <div className="flex items-center gap-3.5">
              <span className="w-6 h-6 rounded-full bg-sahi-green-light flex items-center justify-center shrink-0">
                <Check className="w-3.5 h-3.5 text-sahi-green stroke-[3.5]" />
              </span>
              <span
                className="text-[17px] sm:text-[18px] font-semibold tracking-tight"
                style={{ color: BRAND_DARK }}
              >
                Increase Sales conversion
              </span>
            </div>

            <div className="flex items-center gap-3.5">
              <span className="w-6 h-6 rounded-full bg-sahi-green-light flex items-center justify-center shrink-0">
                <Check className="w-3.5 h-3.5 text-sahi-green stroke-[3.5]" />
              </span>
              <span
                className="text-[17px] sm:text-[18px] font-semibold tracking-tight"
                style={{ color: BRAND_DARK }}
              >
                Smartify Team & Tasks
              </span>
            </div>

            <div className="flex items-center gap-3.5">
              <span className="w-6 h-6 rounded-full bg-sahi-green-light flex items-center justify-center shrink-0">
                <Check className="w-3.5 h-3.5 text-sahi-green stroke-[3.5]" />
              </span>
              <span
                className="text-[17px] sm:text-[18px] font-semibold tracking-tight"
                style={{ color: BRAND_DARK }}
              >
                Enjoy Stress-free Management
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom CTA Button */}
      <div className="w-full pt-8">
        <a
          href={targetUrl}
          className="w-full h-12 flex items-center justify-center gap-2 rounded-xl text-white font-bold text-[16px] sm:text-[17px] bg-sahi-green hover:opacity-95 transition-all active:scale-[0.98] cursor-pointer shadow-md no-underline"
          style={{
            boxShadow: "0 4px 14px var(--sahi-green-light)",
          }}
        >
          <span>{isIOS ? "Continue to App Store" : "Continue to Play Store"}</span>
          <ArrowRight className="w-4.5 h-4.5 stroke-[2.5]" />
        </a>
      </div>
    </div>
  );
}